module.exports = __webpack_public_path__ + "static/media/class (14).02de1f83.webp";